import React from 'react'
import { ModalReturnType } from '../../../hooks/useModal'
import { Modal } from '../../_EOS/Modal'
import { ProductValidationModal } from './ProductValidationModal'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'

export interface ProductValidation {
  workOrderId: number
  workOrderDetailId: number
  pickingRouteId: number
  pickingRouteDetailId: number
  skuId: number
  sku: string
  productName: string
  realQty: number
  validationQty: number | undefined
  validated: boolean
  touched: number
  ean13: string
}

interface ProductValidationProps {
  pickingRouteId: number
  validationModalState: ModalReturnType<unknown>
  refreshGrid: () => void
}

export const ProductValidation: React.FC<ProductValidationProps> = ({
  pickingRouteId,
  validationModalState,
  refreshGrid
}) => {
  const closeModal = () => {
    refreshGrid()
    validationModalState.closeModal()
  }

  const { callApi: validateSkuCallApi, state: validateSkuState } = useApi()

  return (
    <Modal
      loading={validateSkuState.status === Status.Loading}
      open={validationModalState.isOpen}
      title={validationModalState.title}
      onClose={closeModal}
      maxWidth={validationModalState.size}
      cancelButton={{
        action: closeModal,
        title: 'Salir'
      }}
    >
      <ProductValidationModal
        pickingRouteId={pickingRouteId}
        validateSkuCallApi={validateSkuCallApi}
        validateSkuState={validateSkuState}
      />
    </Modal>
  )
}
